import React, { useState } from "react";
import { FaRegCopy } from "react-icons/fa";

export const TryAgainScreen = () => {
  return (
    <>
      <div className="winner-container centerElement">
        <div className="winner-header">
          <div className="winner-icon">
            <img src="/Images/try-agian.png" alt="" />
          </div>
          <h2 className="question-title">Try Again!</h2>
          <p>Sorry! Your mobile number does not match.</p>
        </div>

        <div className="coupon-section">
          <h3>Thank you!</h3>
        </div>
      </div>
    </>
  );
};
